export const gsdPerTreatment = {
  planting_failure: {
    min: 0.5,
    max: 6.0,
  },
  weed: {
    min: 0.5,
    max: 4.5,
  },
  physiology: {
    min: 0.5,
    max: 4.5,
  },
}
